export default (user = {}) => {
  const fullName = [];

  user.firstName && fullName.push(user.firstName);
  user.middleName && fullName.push(user.middleName);
  user.lastName && fullName.push(user.lastName);
  user.alternateName && fullName.push(`(${user.alternateName})`);

  return fullName.join(' ');
};
